import { notify, LEVEL_ERROR } from '../utils/logger';

const storage = {};

function postMsg(event, data) {
  const obj = {
    event,
    data,
  };
  try {
    if (window.parent && window.parent.postMessage) {
      window.parent.postMessage(JSON.stringify(obj), '*');
    }
  } catch (e) {
    notify(e.message, LEVEL_ERROR, 'postMsg');
  }
}

export function scrollTop() {
  postMsg('scrollTop', true);
  console.log('scroll');
}

export function sendHeight(height) {
  const data = { height };
  postMsg('heightChanged', data);
}

export function sendLogin() {
  postMsg('loginRequired', true);
  console.log('login required');
}

export function pageRefreshRequired() {
  postMsg('pageRefreshRequired', true);
  window.location.replace('/refresh');
}

export function loanAmountCalculated(loanRange) {
  const data = {
    minPrice: loanRange.minLoanAmount,
    maxPrice: loanRange.maxLoanAmount,
  };
  postMsg('loanAmountCalculated', data);
  console.log('loan');
}

function isStorage() {
  try {
    if (window.localStorage) {
      const x = 'testStorage';
      window.localStorage.setItem(x, x);
      window.localStorage.removeItem(x);
      return true;
    }
  } catch (e) {
    notify(e.message, LEVEL_ERROR, 'isStorage');
    console.log('storage 0');
    return false;
  }
  return false;
}

function getStorage(name) {
  try {
    return window.localStorage.getItem(name);
  } catch (e) {
    notify(e.message, LEVEL_ERROR, 'getStorage');
    console.log('storage 1');
    return storage[name] || null;
  }
}

function deleteStorage(name) {
  try {
    window.localStorage.removeItem(name);
  } catch (e) {
    notify(e.message, LEVEL_ERROR, 'deleteStorage');
    console.log('storage 2');
    delete storage[name];
  }
}

export function saveToLocal(obj) {
  if (!isStorage()) {
    storage[obj.name] = JSON.stringify(obj);
    return;
  }
  try {
    window.localStorage.setItem(obj.name, JSON.stringify(obj));
  } catch (e) {
    notify(e.message, LEVEL_ERROR, 'saveToLocal');
    console.log('storage 3');
    delete storage[obj.name];
  }
}

export function getLocal(name) {
  if (!isStorage()) return storage[name] || null;
  return getStorage(name);
}

export function removeLocal(name) {
  if (!isStorage()) {
    delete storage[name];
    return;
  }
  deleteStorage(name);
}



// WEBPACK FOOTER //
// ./src/utils/postMessage.js